
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./registerRootComponents": () => {
return Promise.all(/*  | __federation_expose_registerRootComponents */ [__webpack_require__.e("671"), __webpack_require__.e("390"), __webpack_require__.e("470"), __webpack_require__.e("36")]).then(() => (() => (__webpack_require__(7575))));
},
"./register": () => {
return Promise.all(/*  | __federation_expose_register */ [__webpack_require__.e("671"), __webpack_require__.e("390"), __webpack_require__.e("470"), __webpack_require__.e("128")]).then(() => (() => (__webpack_require__(3728))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };